"use strict";

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../../../../typings/tsd.d.ts" />
var TypePhone;
(function (TypePhone) {
    TypePhone[TypePhone["Mobile"] = 0] = "Mobile";
    TypePhone[TypePhone["Commercial"] = 1] = "Commercial";
    TypePhone[TypePhone["Office"] = 2] = "Office";
})(TypePhone || (TypePhone = {}));
var PartnerType;
(function (PartnerType) {
    PartnerType[PartnerType["Person"] = 0] = "Person";
    PartnerType[PartnerType["Company"] = 1] = "Company";
})(PartnerType || (PartnerType = {}));

var State = function State() {
    _classCallCheck(this, State);
};

var City = function City() {
    _classCallCheck(this, City);
};

var Phone = function Phone() {
    _classCallCheck(this, Phone);
};

var Subsidiary = function Subsidiary() {
    _classCallCheck(this, Subsidiary);
};

var Bank = function Bank() {
    _classCallCheck(this, Bank);
};

var BankAgency = function BankAgency() {
    _classCallCheck(this, BankAgency);
};

var BankAccount = function BankAccount() {
    _classCallCheck(this, BankAccount);
};

var Address = function Address() {
    _classCallCheck(this, Address);
};

var RG = function RG() {
    _classCallCheck(this, RG);
};

var CPF = function CPF() {
    _classCallCheck(this, CPF);
};

var Partner = function Partner() {
    _classCallCheck(this, Partner);
};

var Company = function (_Partner) {
    _inherits(Company, _Partner);

    function Company() {
        _classCallCheck(this, Company);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(Company).apply(this, arguments));
    }

    return Company;
}(Partner);

var Person = function (_Partner2) {
    _inherits(Person, _Partner2);

    function Person() {
        _classCallCheck(this, Person);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(Person).apply(this, arguments));
    }

    return Person;
}(Partner);

var AgencyRegistration = function AgencyRegistration() {
    _classCallCheck(this, AgencyRegistration);
};